import styled from "styled-components";

import { ANIMATION_TIMING_FUNCTION, FAST_ANIMATION_DURATION_MS } from "app/modules/project-from-comparison/config";

export const Container = styled.div<{ $isVisible: boolean }>`
    margin-left: 16px;
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    transition: opacity ${FAST_ANIMATION_DURATION_MS}ms ${ANIMATION_TIMING_FUNCTION};
    pointer-events: ${({ $isVisible }) => ($isVisible ? "auto" : "none")};
`;
